const trimTrailingSlashes = (value: string) =>
  value.replace(/\/+$/, '')
const DEFAULT_LOCAL_API_URL = 'https://api.firstdelivery.com'

const normalizeBasePath = (value: string | undefined) => {
  if (!value || value === '/') {
    return '/'
  }

  const trimmedValue = value.trim()

  if (!trimmedValue) {
    return '/'
  }

  const withLeadingSlash = trimmedValue.startsWith('/')
    ? trimmedValue
    : `/${trimmedValue}`

  const normalizedValue = trimTrailingSlashes(withLeadingSlash)

  return normalizedValue || '/'
}

export interface TrackerAppEnv {
  apiBaseUrl: string
  basePath: string
  mapTilesBaseUrl: string
}

export const trackerAppEnv: TrackerAppEnv = {
  apiBaseUrl: import.meta.env.VITE_API_URL || DEFAULT_LOCAL_API_URL,
  basePath: normalizeBasePath(import.meta.env.VITE_BASE_PATH),
  mapTilesBaseUrl: import.meta.env.VITE_MAP_TILES_BASE_URL,
}

if (import.meta.env.DEV) {
  console.log('Order tracker API URL:', trackerAppEnv.apiBaseUrl)
}
